import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import colorContrast from 'color-contrast';
import logo_hr from '../../../assets/images/brand/assista_horizontal-punchout.svg';
import logo from '../../../assets/images/brand/assista.svg';

export const Navbar = ({user, deathDeclaration, partnerColor, logoContent, subsectionsStatuses, serviceSubsectionsStatuses}) => {
    const router = useSelector(state => state.router);
    let onBoardingStepDefault = "0";
    if(!R.isNil(user.onBoardingStep) && (typeof user.onBoardingStep === 'string' || user.onBoardingStep instanceof String)){
        if(user.onBoardingStep === "Completed"){
            onBoardingStepDefault = 6;
        }else{
            onBoardingStepDefault = parseInt(user.onBoardingStep.replace(/\D/g, ""));
        }

    }

    const [onBoardingStep, setOnBoardingStep] = useState(onBoardingStepDefault);

    useEffect(() => {
        if(!R.isNil(user.onBoardingStep)){
            if((typeof user.onBoardingStep === 'string' || user.onBoardingStep instanceof String)){
                if(user.onBoardingStep === "Completed"){
                    setOnBoardingStep(6);
                }else{
                    setOnBoardingStep(parseInt(user.onBoardingStep.replace(/\D/g, "")));
                }
            }else{
                setOnBoardingStep(user.onBoardingStep);
            }
        }


    }, [user.onBoardingStep])

    const colorCustom = (!R.isNil(partnerColor) && partnerColor !== '') ? (colorContrast('#fff', partnerColor) >= 2.5 ? " text-white navbar-dark" : " navbar-light") : " text-white navbar-dark";
    const logo = R.isNil(logoContent) ? logo_hr : logoContent;
    return (
        <header className={"aside onboard-aside navbar navbar-expand-lg py-4 pt-lg-5" + colorCustom}>
            <div className="container-fluid px-gutter justify-content-between align-item-center d-md-flex flex-lg-column h-100">
                <Link className="navbar-brand mr-lg-auto" to={`/facilita`}>
                    <img className={"img-fluid" + (logoContent ? " rounded-sm img-avatar" : "")} src={logo} alt={"Assist@" + (logoContent ? " Partner" : "")} height="80" width="212" onError={(ev) => ev.target.src = logo_hr} />
                    {/* <img className="img-fluid" src={logo} alt="Assist@" width={R.isNil(logoContent) ? "224" :"180"} onError={(ev) => ev.target.src = logo_hr} /> */}
                    <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                </Link>
                <section className={'d-none d-lg-block container-narrow mb-5'}>
                    <h2 className="h2 font-weight-bolder mb-gutter_sm">Un service d’accompagnement personnalisé, bienveillant, simple et qui respecte les délais</h2>

                </section>
                <div className="d-flex align-items-center">
                    <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className={"collapse navbar-collapse flex-column mt-3 mt-lg-0" + ((router.location.pathname === `/facilita/${user.id}/declarer/step1`) ? ' ' : ' pb-lg-0')} id="navbar-collapse">
                    <nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-4 h-100 border-0">
                        <h1 className="sr-only visually-hidden">Menu: navigation</h1>
                        <div className="nav-item show">
                            <div className="card rounded-cta bg-faded text-body shadow text-center">
                                <div className="card-header pb-0">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Référence de</div>
                                    <div className="h4 text-uppercase font-weight-bold lh-1 mb-0">{user.firstName} {user.lastName}</div>
                                </div>
                                <div className="card-footer">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Numéro de processus</div>
                                    <div className="h4 font-weight-bold lh-1 mb-0">{!R.isNil(user) && user.processNumber !== '' ?  user.processNumber : 'N/D'}</div>
                                </div>
                            </div>
                            <ul className="card-body navbar-nav">
                                <NavLink className={"nav-item" + ((onBoardingStep > 1) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${user.id}/onboarding/step1`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Informations du défunt</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                    <div className="feedback text-body">
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.civilForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Etat civil</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small"  + (subsectionsStatuses.familySituationForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Situation familiale</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.childrenForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Enfants</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.residenceForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Coordonnées</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.professionalSituationForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Situation Professionnelle</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 3) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${user.id}/onboarding/step2`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Le service</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                    <div className="feedback text-body">
                                        <div role="button" className={"d-flex align-items-center small text-white"}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Démarches communes</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small"  + (serviceSubsectionsStatuses.demarchesPersonalisee ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Démarches personnalisées</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 4) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${user.id}/onboarding/step3`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">La situation du défunt</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 5) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${user.id}/onboarding/step4`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Validation</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                            </ul>
                        </div>
                    </nav>
                    {/* <Link className="btn btn-light btn-block px-2 mt-auto text-body" to="/facilita">Annuler</Link> */}
                </div>
            </div>
        </header>
    )
}